import * as i0 from "@angular/core";
var AnalyticsService = /** @class */ (function () {
    function AnalyticsService() {
    }
    AnalyticsService.prototype.pageView = function (pageLocation, pageTitle) {
        gtag('event', 'page_view', {
            'page_location': pageLocation,
            'page_title': pageTitle
        });
    };
    AnalyticsService.prototype.trackEvent = function (eventName, eventDetails, eventCategory) {
        gtag('event', eventName, {
            'Event_Category': eventCategory,
            // the label that will show up in the dashboard as the events name
            'Event_Label': eventName,
            'Event_Action': eventDetails
        });
    };
    AnalyticsService.ngInjectableDef = i0.defineInjectable({ factory: function AnalyticsService_Factory() { return new AnalyticsService(); }, token: AnalyticsService, providedIn: "root" });
    return AnalyticsService;
}());
export { AnalyticsService };
